/*
 * pg-desc-img.js — נוסף 8.8.2026 (קוד מותאם אישית, לא חלק מהתמה המקורית)
 *
 * הבעיה שתוקנה כאן
 * ----------------
 * התמה מריצה את תיאור המוצר דרך המרת lazyload בצד השרת שמחפשת מחרוזת
 * ליטרלית — התחילית "<img src=". כשהתכונה src היא הראשונה בתג, ההמרה תופסת:
 *   src   מוחלף ב-GIF שקוף בגודל 1x1 (data:image/gif;base64,...)
 *   המקור עובר ל-data-src
 *   נוספת class="lazyload"
 * אבל lazysizes לא מבצע unveil לתמונות האלה בפועל — הן יושבות בתוך פאנל
 * טאב/אקורדיון ולא מקבלות את אירוע ה-scroll שמפעיל את הבדיקה. נמדד: גם
 * שלוש שניות אחרי הטעינה naturalWidth נשאר 1, ורק אירוע scroll אמיתי
 * הטעין אותן. התוצאה: האייקונים בתיאור נראים לרגע ואז נשארים ריקים.
 *
 * למה זה קרה רק בחלק מהמוצרים: העורך של Shopify (TinyMCE) לעיתים מוסיף
 * תכונות (data-mce-*, style, width, height) לפני src. במקרים כאלה ההמרה
 * לא תופסת והתמונה נשארת רגילה ונטענת כרגיל. לכן מוצר עם חמישה אייקונים
 * הציג ארבעה תקינים ואחד ריק — בדיוק זה שבו src היה ראשון.
 *
 * הפתרון: להטעין מיידית (eager) כל תמונה כזו בתוך תוכן עשיר (.rte) —
 * להעביר data-src -> src ולהסיר את מחלקות ה-lazyload. גנרי לכל המוצרים,
 * ולא נוגע בקובץ הספק sections/product-template.liquid (28.5KB) שבו
 * יושבת ההמרה עצמה.
 *
 * תיחום מכוון: רק בתוך .rte (תיאור המוצר, טאבים מותאמים, מטאאובייקטים).
 * גלריית המוצר, רשת הקולקציה ושאר תמונות התמה ממשיכות ב-lazyload רגיל.
 */
(function () {
  'use strict';

  var PLACEHOLDER = /^data:image\/gif/i;

  function unveil(img) {
    var src = img.getAttribute('data-src');
    if (!src) return;
    var cur = img.getAttribute('src') || '';
    // לא נוגעים בתמונה שכבר נטענה עם src אמיתי
    if (cur && !PLACEHOLDER.test(cur)) return;
    img.setAttribute('src', src);
    img.removeAttribute('data-src');
    img.classList.remove('lazyload', 'lazyloading');
    img.classList.add('lazyloaded'); // .lazyload מוגדר opacity:0 מתחת ל-992px
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var imgs = scope.querySelectorAll('.rte img[data-src]');
    for (var i = 0; i < imgs.length; i++) unveil(imgs[i]);
  }

  function init() {
    scan(document);
    // תוכן שנוסף מאוחר (quickview, החלפת טאב, אפליקציות) — סריקה חוזרת
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var added = muts[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('img[data-src]') && n.closest('.rte')) unveil(n);
          else if (n.querySelectorAll) scan(n);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
